module.exports = __webpack_public_path__ + "static/assets/d8a9410dcb59312a40f52bb00dfbea13.gif";